import { render, staticRenderFns } from "./AssignCaliberAssistantNew.vue?vue&type=template&id=25df4f8d"
import script from "./AssignCaliberAssistantNew.vue?vue&type=script&lang=js"
export * from "./AssignCaliberAssistantNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports